<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="编辑支出分类"
      width="500"
      :open="open"
      @close="close"
      class="update-dialog"
    >
      <mu-form :model="editForm" label-position="left" label-width="100">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="editForm.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="editForm.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {}
    }
  },
  methods: {
    submit() {
      backend(api.outcategory.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.update-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/outCategory/update.vue